/**
 * Untyped data accessor for the external Supabase project.
 *
 * Previously this module called createClient() a second time against the
 * same external project, which spawned a duplicate GoTrueClient and
 * produced the "Multiple GoTrueClient instances" console warning. We now
 * re-export the singleton from `client.ts` so there is exactly one client
 * per Supabase project (external data + Lovable Cloud auth = 2 total).
 */
import { supabase as singleton } from './client';

export const supabase = singleton as any;

/**
 * Untyped wrapper around supabase.from() for selective usage.
 */
export const supabaseFrom = (table: string) => (supabase as any).from(table);
